import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HomePage } from '@/pages/home/HomePage';
import { SubscriptionDetailPage } from '@/pages/subscription-detail/SubscriptionDetailPage';
import { SubscriptionSettingsPage } from '@/pages/subscription-settings/SubscriptionSettingsPage';
import { CollectionDetailPage } from '@/pages/collection-detail/CollectionDetailPage';
import { CreatePage } from '@/pages/create/CreatePage';
import { PaymentsPage } from '@/pages/payments/PaymentsPage';
import { HistoryPage } from '@/pages/history/HistoryPage';
import { SettingsPage } from '@/pages/settings/SettingsPage';
import { InvitationPage } from '@/pages/invitation/InvitationPage';
import { ArchivePage } from '@/pages/archive/ArchivePage';
import { ChangePrice } from '@/features/change-price/ChangePrice';
import { CloseSubscription } from '@/features/close-subscription/CloseSubscription';
import { MemberDetail } from '@/features/member-management/MemberDetail';
import { InviteMember } from '@/features/invite-member/InviteMember';
import { ManualCorrection } from '@/features/manual-correction/ManualCorrection';
import { ApproveExit } from '@/features/approve-exit/ApproveExit';
import { AttachReceipt } from '@/features/attach-receipt/AttachReceipt';

export function AppRouter() {
  return (
    <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/subscriptions/:id" element={<SubscriptionDetailPage />} />
        <Route path="/subscriptions/:id/change-price" element={<ChangePrice />} />
        <Route path="/subscriptions/:id/close" element={<CloseSubscription />} />
        <Route path="/subscriptions/:id/settings" element={<SubscriptionSettingsPage />} />
        <Route path="/subscriptions/:id/members/:membershipId" element={<MemberDetail />} />
        <Route path="/subscriptions/:id/members/:membershipId/correction" element={<ManualCorrection />} />
        <Route path="/subscriptions/:id/exit-requests/:exitRequestId/approve" element={<ApproveExit />} />
        <Route path="/subscriptions/:id/add-member" element={<InviteMember />} />
        <Route path="/collections/:id" element={<CollectionDetailPage />} />
        <Route path="/create" element={<CreatePage />} />
        <Route path="/payments" element={<PaymentsPage />} />
        <Route path="/history" element={<HistoryPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/archive" element={<ArchivePage />} />
        <Route path="/invite/:token" element={<InvitationPage />} />
        <Route path="/payment-claims/:claimId/attach-receipt" element={<AttachReceipt />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
